var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 41,
    viewBox: "0 0 169 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_8788)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1660_8788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 168,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.784 0.0703125H0.0703125V40.0703H167.784V0.0703125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1660_8788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5601 6.19487L34.7642 7.46018C34.7642 7.54181 35.0091 8.88875 35.0091 11.052C35.0091 13.0928 34.805 15.8275 34.0703 18.8887C33.3356 21.7867 32.0703 25.256 29.703 28.6438C27.3356 32.0316 23.907 35.3785 18.9274 38.0316L18.3152 38.3581L17.7438 38.0316C12.7642 35.3785 9.33562 32.0316 7.00909 28.6438C4.64174 25.256 3.33562 21.7867 2.64174 18.8887C1.90704 15.8275 1.70296 13.0928 1.70296 11.052C1.70296 8.88875 1.90704 7.54181 1.94786 7.46018L2.11113 6.19487C2.19276 5.74589 1.90704 5.33773 1.45807 5.29691C1.00909 5.21528 0.600924 5.50099 0.560109 5.94997L0.356027 7.21528C0.31521 7.33773 0.0703125 8.80711 0.0703125 11.052C0.0703125 13.1744 0.274395 16.0724 1.0499 19.256C1.7846 22.3173 3.17235 25.9499 5.66215 29.5418C8.15194 33.1336 11.7438 36.6438 16.9683 39.4601L17.9479 39.9907C18.1927 40.1132 18.4785 40.1132 18.7234 39.9907L19.703 39.4601C24.8866 36.6438 28.5193 33.1336 31.0091 29.5418C33.4989 25.9499 34.8866 22.3173 35.6213 19.256C36.3968 16.0724 36.6009 13.1744 36.6009 11.0111C36.6009 8.7663 36.356 7.33773 36.356 7.17446L36.1519 5.90916C36.0703 5.46018 35.6621 5.17446 35.254 5.25609C34.805 5.33773 34.4785 5.74589 34.5601 6.19487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48172 5.33714L18.3593 1.70448L30.4817 5.41877C30.8899 5.54122 31.3389 5.29632 31.4613 4.88816C31.5838 4.48 31.3389 4.03102 30.9307 3.90857L18.5633 0.112644C18.4409 0.0718272 18.2776 0.0718272 18.1144 0.112644L5.99193 3.78612C5.58376 3.90857 5.33887 4.35755 5.46131 4.76571C5.58376 5.21469 6.03274 5.45959 6.48172 5.33714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.603484 6.43943L17.6239 39.6231C17.7463 39.868 18.032 40.0721 18.3178 40.0721C18.6035 40.0721 18.8892 39.9088 19.0116 39.6639L29.379 20.2762V20.2354L36.032 6.43943C36.2361 6.03126 36.0729 5.58228 35.6647 5.3782C35.2565 5.17412 34.8076 5.33738 34.6035 5.74555L27.9912 19.5007L18.3586 37.5415L2.03205 5.70473C1.82797 5.29657 1.33818 5.17412 0.970831 5.3782C0.562668 5.54147 0.399403 6.03126 0.603484 6.43943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76164 21.2146H27.7004C28.1494 21.2146 28.5167 20.8473 28.5167 20.3983C28.5167 19.9493 28.1494 19.582 27.7004 19.582H8.76164C8.31266 19.582 7.94531 19.9493 7.94531 20.3983C7.94531 20.8473 8.31266 21.2146 8.76164 21.2146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.543 14.318H49.2164C49.0124 14.318 48.8083 14.3996 48.645 14.5629C48.4818 14.7261 48.4001 14.8894 48.4001 15.1343V25.0118C48.4001 25.2159 48.4818 25.42 48.645 25.5833C48.8083 25.7465 48.9715 25.8282 49.2164 25.8282H61.543V27.5016H49.2164C48.5226 27.5016 47.9511 27.2567 47.4613 26.7669C46.9715 26.2771 46.7266 25.7057 46.7266 25.0118V15.1343C46.7266 14.4404 46.9715 13.869 47.4613 13.3792C47.9511 12.8894 48.5226 12.6445 49.2164 12.6445H61.543V14.318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.643 12.6445V14.318H72.8063V19.2159H82.3165V20.8894H72.8063V25.7873H84.643V27.4608H71.1328V12.6445H84.643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05 15.1326V19.4591C109.05 20.153 108.805 20.7244 108.316 21.2142C107.826 21.704 107.254 21.9489 106.561 21.9489H104.316L108.969 27.4591H106.765L102.152 21.9489H96.7242C96.6017 21.9489 96.316 21.9081 95.9078 21.8673V27.4591H94.2344V12.6836H106.601C107.295 12.6836 107.867 12.9285 108.357 13.4183C108.805 13.8673 109.05 14.4795 109.05 15.1326ZM96.6833 20.2754H106.601C106.805 20.2754 107.01 20.1938 107.173 20.0305C107.336 19.8673 107.418 19.704 107.418 19.4591V15.1326C107.418 14.9285 107.336 14.7244 107.173 14.5612C107.01 14.3979 106.846 14.3163 106.601 14.3163H96.7242C96.5201 14.3163 96.316 14.3979 96.1527 14.5612C95.9895 14.7244 95.9078 14.8877 95.9078 15.1326V19.4591C95.9078 19.6632 95.9895 19.8673 96.1527 20.0305C96.2752 20.1938 96.4793 20.2754 96.6833 20.2754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.906 12.6445H132.722V14.318H126.151V27.4608H124.477V14.318H117.906V12.6445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.711 27.5016V12.6445H143.384V27.4608H141.711V27.5016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.625 12.6445H167.747L161.543 20.0731L167.747 27.5016H165.584L160.074 20.9302H155.298V27.5016H153.625V12.6445H155.298V19.2159H160.074L165.625 12.6445Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_8788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 40,
    fill: "white",
    transform: "translate(0.0703125 0.0703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertik);
export default __webpack_public_path__ + "static/media/certik.720a4f0a1ea3eb35005da42af45afca7.svg";
export { ForwardRef as ReactComponent };